export interface IDonorConnectCenterContacts {
    centerAlias: string,
    firstName: string,
    lastName: string,
    email: string,
    positions: string,
    positionType: string,
    phoneNumbers: string
}